import React from "react"
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { transformData } from "helpers/dataTransformer"
// import { getNotificationService } from "services/merchant-orders.service"
import {
  updateNotificationService,
  getAdminNotificationService,
  getAdminNotificationPageService
} from "services/notifications.service"

export const getAdminNotifications = createAsyncThunk(
  "getAdminNotifications",
  async (params, { rejectWithValue }) => {
    return await getAdminNotificationService(params, rejectWithValue)
  }
)

export const getAdminNotificationsPage = createAsyncThunk(
  "getAdminNotificationsPage",
  async (params, { rejectWithValue }) => {
    return await getAdminNotificationPageService(params, rejectWithValue)
  }
)

export const updateAdminNotifications = createAsyncThunk(
  "putAdminNotifications",
  async ({ data, id, config = {} }, { rejectWithValue }) => {
    return await updateNotificationService(id, data, rejectWithValue, config)
  }
)

const initialLog = {
  type: "",
  error: false,
  message: null,
  loading: false,
  success: false,
}

const initialState = {
  adminNotificationsArr: [],
  adminNotificationsPageArr: [],
  included: [],
  logs: initialLog,
  meta: null,
}

const slice = createSlice({
  name: "adminNotifications",
  initialState,
  reducers: {
    // resetAgencyMyOrdersState: state => {
    //   ;(state.myOrders = []), (state.included = []), (state.logs = initialLog)
    // },
  },
  extraReducers: {
    [getAdminNotifications.pending]: state => {
      state.logs = {
        ...initialLog,
        loading: true,
        type: "getAdminNotifications",
      }
    },
    [getAdminNotifications.fulfilled]: (state, action) => {
      state.adminNotificationsArr = transformData(action.payload)
      state.logs = { ...state.logs, success: true, loading: false }
    },
    [getAdminNotifications.rejected]: (state, action) => {
      state.logs = {
        ...state.logs,
        loading: false,
        error: action?.payload?.errors,
        message: action?.payload?.errors ? (
          <p>{`${action?.payload?.errors[0]?.code}. ${action?.payload?.errors[0]?.detail}`}</p>
        ) : (
          "Something went wrong"
        ),
      }
    },
    [getAdminNotificationsPage.pending]: state => {
      state.logs = {
        ...initialLog,
        loading: true,
        type: "getAdminNotificationsPage",
      }
    },
    [getAdminNotificationsPage.fulfilled]: (state, action) => {
      state.meta = action.payload.result.meta
      state.adminNotificationsPageArr = transformData(action.payload)
      state.logs = { ...state.logs, success: true, loading: false }
    },
    [getAdminNotificationsPage.rejected]: (state, action) => {
      state.logs = {
        ...state.logs,
        error: true,
        loading: false,
        message: action?.payload?.errors ? (
          <p>{`${action?.payload?.errors[0]?.code}. ${action?.payload?.errors[0]?.detail}`}</p>
        ) : (
          "Something went wrong"
        ),
      }
    },
    [updateAdminNotifications.pending]: state => {
      state.logs = {
        ...initialLog,
        loading: true,
        type: "putAdminNotifications",
      }
    },
    [updateAdminNotifications.fulfilled]: (state, action) => {
      state.logs = {
        ...state.logs,
        success: true,
        loading: false,
      }
      // console.log("PUT Notif Success")
    },
    [updateAdminNotifications.rejected]: (state, action) => {
      state.logs = {
        ...state.logs,
        error: true,
        loading: false,
        message: action?.payload?.errors
          ? action?.payload?.errors[0]?.detail
          : "Something went wrong",
      }
      // console.log("PUT Notif Error")
    },
    ["PURGE"]: () => {
      return initialState
    },
  },
})

export const { reducer } = slice

// export const resetAgencyMyOrdersStateThunk = () => dispatch => {
//   dispatch(slice.actions.resetAgencyMyOrdersState())
// }

export default slice
